var req = require("!!/app/node_modules/pug-loader/index.js??ref--13-1!/app/src/linagora.esn.contact/app/search/contact-search.pug");
module.exports = (req['default'] || req).apply(req, [])